export class Validation {
    public static isIMEIValid(imei: string) {
        if (!/^[0-9]{15}$/.test(imei)) {
            return false;
        }

        let sum = 0;
        let factor = 2;
        let multipliedDigit;

        for (let i = 13, li = 0; i >= li; i--) {
            multipliedDigit = parseInt(imei.charAt(i), 10) * factor;
            sum += multipliedDigit >= 10 ? (multipliedDigit % 10) + 1 : multipliedDigit;
            factor === 1 ? factor++ : factor--;
        }
        const checkDigit = (10 - (sum % 10)) % 10;

        return !(checkDigit !== parseInt(imei.charAt(14), 10));
    }
}
